import {inject, IReactComponent} from 'mobx-react';
import * as component from './component';

const mapStoresToProps = (stores: any) => ({
    translate: stores.inviteStore?.localizationService?.translate?.bind(stores.inviteStore.localizationService)
});

const BottomBar = inject(mapStoresToProps)(component.BottomBar) as IReactComponent;

export {BottomBar};
export default BottomBar;
